import {
  getReversePopupType,
  isPathnameOkForWithdrawalReject,
  isWithdrawalRejectBilletClosedCookieSet,
} from 'Modulor/components/WithdrawalReject/utils';
import { useNavigateWithSearch } from 'Modulor/hooks';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  isPartialReverseEnabledSelector,
  isWithdrrawalRejectOpened,
  pendingWithdrawalsSelector,
  setIsOpened,
  withdrawalRejectInfoSelector,
} from 'store/slices/withdrawalReject';

import { Routes } from '../Modulor/routes';

export const useWithdrawalRejectToggle = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigateWithSearch();
  const location = useLocation();
  const { pathname } = location;
  const isOpened = useAppSelector(isWithdrrawalRejectOpened);
  const withdrawalRejectInfo = useAppSelector(withdrawalRejectInfoSelector);
  const pendingWithdrawals = useAppSelector(pendingWithdrawalsSelector);
  const isPartialReverseEnabled = useAppSelector(isPartialReverseEnabledSelector);
  const isPathnameOk = isPathnameOkForWithdrawalReject(pathname);
  const isClosedCookieSet = isWithdrawalRejectBilletClosedCookieSet();
  const state = location.state as { background?: Location } | undefined;
  const isModalRouteActive = pathname.includes('reject-withdrawal');
  const popupType = getReversePopupType({
    withdrawalReverseAmount: withdrawalRejectInfo?.amount,
    pendingWithdrawals,
    isPartialReverseEnabled,
  });

  useEffect(() => {
    const okForRender = Boolean(!isOpened && popupType !== 'none' && !isClosedCookieSet && isPathnameOk);

    if (okForRender) {
      navigate('/reject-withdrawal', {
        state: {
          background: location,
          from: Routes.deposit,
        },
        replace: true,
      });
      dispatch(setIsOpened(true));
      return;
    }

    if (isOpened && !isModalRouteActive && !state?.background) {
      navigate('/reject-withdrawal', {
        state: {
          background: location,
          from: Routes.deposit,
        },
        replace: true,
      });
    }
  }, [isPathnameOk, isClosedCookieSet, popupType, isOpened, isModalRouteActive, state?.background]);
};
